/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { InerestRecievedTableHead } from './TableHead';
import { getInterestRecievedReports } from '../Store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';

const InterestRecievedDetail = (props) => {
  const dispatch = useDispatch();

  const {
    isLoading,
    displayObj: { fromDateValue: fromDate, toDateValue: toDate, searchResult },
  } = useSelector((state) => state?.sharedState?.InterestRecievedReducer);
  let fromDateValue = fromDate;
  let toDateValue = toDate;
  if (fromDateValue.includes('Q')) {
    fromDateValue = convertStringDate(quarterToDate(fromDateValue, 'fromDate'));
  }
  if (toDateValue?.includes('Q')) {
    toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
  }
  const [rows, setRows] = React.useState([]);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [filterApply, setFilterApply] = React.useState(false);

  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Interest Recievd api call at initial load
  React.useEffect(() => {
    dispatch(
      getInterestRecievedReports({
        startDate: fromDateValue,
        endDate: toDateValue || fromDateValue,
      })
    );
  }, []);

  // Set the table data rows
  React.useEffect(() => {
    const data = searchResult.map((item) => {
      return {
        ...item,
        interestPaidAmt: parseFloat(item.interestPaidAmt.toFixed(2)),
      };
    });
    setRows(data);
  }, [searchResult]);
  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rows;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : 0.0;
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        interestPaidAmt: sum('interestPaidAmt'),

        invRecQtr: 'Grand Total',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  const dateToShow = `${fromDateValue}-${toDateValue || fromDateValue}`;

  // variable for PDF header slected information

  const secondInfo = `Deposit Dates: ${dateToShow} `;

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Interest Received Display"
      />

      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="From Date: "
                          id="From Date"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={fromDateValue}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="To Date: "
                          id="To Date"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={toDateValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div
            className="unallocated bottom-pinned-bold"
            style={{ width: '100vw' }}
          >
            <TableGridWithFeatures
              gridHeight={fullScreenView ? 600 : viewPortHeight_355}
              columnDefs={InerestRecievedTableHead}
              rowData={rows}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              onFilterData={onFilterChanged}
              getFilterApply={getFilterApply}
              hideTotalCount={false}
              exportFile
              // isScrollOn
              fileName="InterestReceived "
              reportName="Interest Received Report"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ secondInfo }}
              pinnedBottomRowData={pinnedBottomRowData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestRecievedDetail;
